import React from "react";

import { AuthService } from "./auth/AuthService";
import { RouteType } from "../constants/RouteType";
import { FormikValues } from "formik";

export class UserRegisterService {
  static saveRegistration = async (itemData: FormikValues) => {
    const url = RouteType.AUTH + RouteType.REGISTER;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(itemData)
    );
    return response;
  };

  static editRegistration = async (itemData: FormikValues) => {
    const url = RouteType.EDIT_BUSINESS;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(itemData)
    );
    return response;
  };

  static saveRegistrationAfterLogin = async (itemData: FormikValues) => {
    const url = RouteType.CREATE_BUSINESS;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(itemData)
    );
    return response;
  };

  //create corporate api

  static saveCorporateManagement = async (itemData: FormikValues) => {
    const url = RouteType.CORPORATES;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(itemData)
    );
    return response;
  };

  static getPermissions = async () => {
  const url = RouteType.AUTH + RouteType.PERMISSIONS;
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };
}
